/**
 * @param {string} value - the value to show in badge
 * @param {string} [backgroundColor] - background color for badge, default white
 * @param {string} [borderColor] - border color for badge, by default, it will be same as backgroundColor
 * @param {string} [textColor] - text color
 * @param {StyleSheet} [style] - additional style
 * @param {StyleSheet} [containerStyle] - additional container style
 * @param {React.ReactNode} children - React Node contents
 * @returns {React.ReactNode}
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { theme } from '../styles';

type BadgeProps = {
  value: string;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  style?: object;
  containerStyle?: object;
  children: React.ReactNode;
};

export const Badge: React.FC<BadgeProps> = ({
  value,
  backgroundColor = theme.colors.white,
  borderColor = backgroundColor,
  textColor = theme.colors.black,
  style,
  containerStyle,
  children,
}) => {
  return (
    <View style={containerStyle}>
      <View style={[styles.container, { backgroundColor }, { borderColor }, style]}>
        <Text style={[theme.text.bold, { color: textColor }]}>{value}</Text>
      </View>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: -10,
    right: -10,
    borderRadius: 10,
    minWidth: 15,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2,
    borderStyle: 'solid',
    borderWidth: 1,
  },
});
